import mixins from '@synergycms_core/less/mixins';

export default {
  defaultStyle: {},
  roomSelected:{},
  hide: {
    display: 'none'
  },
  selected: {
    backgroundColor: 'green',
  },
  roomDetailWrapper: {
    ...mixins.displayFlex('row', 'left', 'baseline', '0'),
    padding: '0.5em',
    textAlign: 'left',
    boxSizing: 'border-box',
    '@media (min-width:801px)': {
      width: '170px',
    },
  },
  roomDetailLine: {
    ...mixins.displayFlex('column', '', 'start', '0.5em'),
    padding: '0.5em',
  },
  roomDetailText:{
    cursor: 'pointer',
    '& span':{
      '@media (min-width:801px)': {
        fontSize: '20px'
      },
    },
    '&$roomSelected':{
      '& span':{
        fontWeight: 'bold',
      }
    }
  },
  roomDetailCheck:{
    marginLeft: '10px',
    color: data => data.mainColor,
    '@media (min-width:801px)': {
      fontSize: '20px'
    },
  },
  zIndexDatePicker:{
    zIndex: 'unset',
  },
  roomsName:{
    width: '120px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block'
  }
};